import { useEffect, useState } from "react";
import PillButton from "./pill-button";

export default function PillMenu(props) {
    const [pillsOptions, setpillsOptions] = useState([]);
    useEffect(() => {
        setpillsOptions(props.items.map((item, index) => {
            if (!item.option.length) {
                return <></>;
            }
            return <PillButton title={item.option_name} index={index} onPillClick={props.onPillClick}></PillButton>
        }));
    },[props.items]);

    return (
        <div className="pill-menu">
            {pillsOptions}
        </div>
    )
}